"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var vec2 = require('gl-matrix/src/gl-matrix/vec2');
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
var Polygon = (function () {
    function Polygon(loX, loZ, hiX, hiZ, y) {
        this.lo = vec2.fromValues(loX, loZ);
        this.hi = vec2.fromValues(hiX, hiZ);
        this.y = y;
        this.center = vec3.fromValues((this.hi[0] + this.lo[0]) / 2, y, (this.hi[1] + this.lo[1]) / 2);
    }
    return Polygon;
}());
exports.Polygon = Polygon;
var Node = (function (_super) {
    __extends(Node, _super);
    function Node(navmesh, loX, loZ, hiX, hiZ, y) {
        _super.call(this, loX, loZ, hiX, hiZ, y);
        this.navmesh = navmesh;
        this.edges = [];
    }
    Node.getDistance = function (src, dest) {
        return vec3.distance(src.center, dest.center);
    };
    Node.prototype.addEdge = function (dest) {
        var portal;
        if (this.hi[0] <= dest.lo[0]) {
            portal = [
                vec3.fromValues(this.hi[0], this.y, Math.max(this.lo[1], dest.lo[1])),
                vec3.fromValues(this.hi[0], this.y, Math.min(this.hi[1], dest.hi[1])),
            ];
        }
        else if (this.lo[0] >= dest.hi[0]) {
            portal = [
                vec3.fromValues(this.lo[0], this.y, Math.min(this.hi[1], dest.hi[1])),
                vec3.fromValues(this.lo[0], this.y, Math.max(this.lo[1], dest.lo[1])),
            ];
        }
        else if (this.hi[1] <= dest.lo[1]) {
            portal = [
                vec3.fromValues(Math.min(this.hi[0], dest.hi[0]), this.y, this.hi[1]),
                vec3.fromValues(Math.max(this.lo[0], dest.lo[0]), this.y, this.hi[1]),
            ];
        }
        else if (this.lo[1] >= dest.hi[1]) {
            portal = [
                vec3.fromValues(Math.max(this.lo[0], dest.lo[0]), this.y, this.lo[1]),
                vec3.fromValues(Math.min(this.hi[0], dest.hi[0]), this.y, this.lo[1]),
            ];
        }
        else {
            // TODO: Support stitching nodes on different y
            throw new Error('Unsupported');
        }
        var length = Node.getDistance(this, dest);
        var edge = {
            src: this,
            dest: dest,
            length: length,
            portal: portal,
        };
        this.edges.push(edge);
        return edge;
    };
    Node.prototype.removeEdge = function (edge) {
        var index = this.edges.indexOf(edge);
        if (index !== -1) {
            this.edges.splice(index, 1);
        }
        edge.src = null;
        edge.dest = null;
    };
    return Node;
}(Polygon));
exports.Node = Node;
(function (Face) {
    Face[Face["LEFT"] = 0] = "LEFT";
    Face[Face["RIGHT"] = 1] = "RIGHT";
    Face[Face["TOP"] = 2] = "TOP";
    Face[Face["BOTTOM"] = 3] = "BOTTOM";
    Face[Face["FRONT"] = 4] = "FRONT";
    Face[Face["BACK"] = 5] = "BACK";
})(exports.Face || (exports.Face = {}));
var Face = exports.Face;
exports.OppositeFace = (_a = {},
    _a[Face.LEFT] = Face.RIGHT,
    _a[Face.RIGHT] = Face.LEFT,
    _a[Face.TOP] = Face.BOTTOM,
    _a[Face.BOTTOM] = Face.TOP,
    _a[Face.FRONT] = Face.BACK,
    _a[Face.BACK] = Face.FRONT,
    _a
);
var Tangent = (_b = {},
    _b[Face.LEFT] = 1,
    _b[Face.RIGHT] = 1,
    _b[Face.FRONT] = 0,
    _b[Face.BACK] = 0,
    _b
);
var NavMesh = (function () {
    function NavMesh(x, y, z, width, height, depth) {
        this.size = vec3.fromValues(width, height, depth);
        this.offset = vec3.fromValues(x, y, z);
        this.nodes = [];
        this.nodesIdxY = [];
        for (var i = 0, len = this.size[1]; i <= len; ++i) {
            this.nodesIdxY.push([]);
        }
        this.edgesOnFace = [[], [], [], [], [], []];
        this.nodesOnFace = [[], [], [], [], [], []];
    }
    NavMesh.prototype.addPolygon = function (loX, loZ, hiX, hiZ, y) {
        var node = new Node(this, loX + this.offset[0], loZ + this.offset[2], hiX + this.offset[0], hiZ + this.offset[2], y + this.offset[1]);
        this.nodes.push(node);
        this.nodesIdxY[y].push(node);
        if (loX === 0) {
            this.nodesOnFace[Face.RIGHT].push(node);
        }
        if (hiX === this.size[0]) {
            this.nodesOnFace[Face.LEFT].push(node);
        }
        if (loZ === 0) {
            this.nodesOnFace[Face.BACK].push(node);
        }
        if (hiZ === this.size[2]) {
            this.nodesOnFace[Face.FRONT].push(node);
        }
        if (y === 0) {
            this.nodesOnFace[Face.BOTTOM].push(node);
        }
        if (y === this.size[1]) {
            this.nodesOnFace[Face.TOP].push(node);
        }
    };
    NavMesh.prototype.computeEdges = function () {
        for (var i = 0, leny = this.size[1]; i <= leny; ++i) {
            var nodes = this.nodesIdxY[i];
            var len = nodes.length;
            for (var j = 0; j < len; ++j) {
                var na = nodes[j];
                for (var k = j + 1; k < len; ++k) {
                    var nb = nodes[k];
                    var connected = false;
                    if (na.lo[0] === nb.hi[0] || na.hi[0] === nb.lo[0]) {
                        if (na.lo[1] < nb.hi[1] && na.hi[1] > nb.lo[1]) {
                            connected = true;
                        }
                    }
                    else if (na.lo[1] === nb.hi[1] || na.hi[1] === nb.lo[1]) {
                        if (na.lo[0] < nb.hi[0] && na.hi[0] > nb.lo[0]) {
                            connected = true;
                        }
                    }
                    if (connected) {
                        na.addEdge(nb);
                        nb.addEdge(na);
                    }
                }
            }
        }
    };
    NavMesh.prototype.connectRight = function (other) {
        return this.connectHorizontal(Face.RIGHT, other);
    };
    NavMesh.prototype.connectLeft = function (other) {
        return this.connectHorizontal(Face.LEFT, other);
    };
    NavMesh.prototype.connectFront = function (other) {
        return this.connectHorizontal(Face.FRONT, other);
    };
    NavMesh.prototype.connectBack = function (other) {
        return this.connectHorizontal(Face.BACK, other);
    };
    NavMesh.prototype.connectTop = function (other) {
        // TODO: Implementation
    };
    NavMesh.prototype.connectBottom = function (other) {
        // TODO: Implementation
    };
    NavMesh.prototype.searchNode = function (pos) {
        var nodes = this.nodesIdxY[pos[1]];
        if (!nodes)
            return null;
        for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
            var n = nodes_1[_i];
            if (n.lo[0] <= pos[0] &&
                n.hi[0] >= pos[0] &&
                n.lo[1] <= pos[2] &&
                n.hi[1] >= pos[2]) {
                return n;
            }
        }
        return null;
    };
    NavMesh.prototype.connect = function (face, other) {
        switch (face) {
            case Face.LEFT:
            case Face.RIGHT:
            case Face.FRONT:
            case Face.BACK:
                {
                    this.connectHorizontal(face, other);
                    break;
                }
            case Face.TOP:
            case Face.BOTTOM:
                {
                    break;
                }
        }
    };
    NavMesh.prototype.connectHorizontal = function (face, other) {
        var edgesOnFace = this.edgesOnFace[face];
        for (var _i = 0, edgesOnFace_1 = edgesOnFace; _i < edgesOnFace_1.length; _i++) {
            var edge = edgesOnFace_1[_i];
            edge.src.removeEdge(edge);
        }
        edgesOnFace = this.edgesOnFace[face] = [];
        var t = Tangent[face];
        for (var _a = 0, _b = other.nodesOnFace[exports.OppositeFace[face]]; _a < _b.length; _a++) {
            var dest = _b[_a];
            for (var _c = 0, _d = this.nodesOnFace[face]; _c < _d.length; _c++) {
                var src = _d[_c];
                if (src.y === dest.y &&
                    src.hi[t] > dest.lo[t] &&
                    src.lo[t] < dest.hi[t]) {
                    edgesOnFace.push(src.addEdge(dest));
                }
            }
        }
    };
    return NavMesh;
}());
exports.NavMesh = NavMesh;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = NavMesh;
var _a, _b;
//# sourceMappingURL=NavMesh.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/pathfinder/lib/NavMesh.js
 ** module id = 213
 ** module chunks = 0
 **/